import React, { lazy } from 'react';
import { Card } from '../UI/Card';
import { Button } from '../UI/Button';
import { Link } from 'react-router-dom';
export const SuccessStories = () => {
  const stories = [{
    name: 'Blackman',
    city: 'Benin',
    story: 'I attended the second edition that held in Benin city, and I was able to get a speaking gig that led on to expanding my work to Abuja.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xg79LuBq9qCVoncHNm52aL/Blackman.png'
  }, {
    name: 'Ruth',
    city: 'Lagos',
    story: 'When I started my organization, I got guidance from the curator of the networking salon, and also access to trainers for my event.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2vwTMEx2nxEJnE1zhS1xa9/Ruth.png'
  }, {
    name: 'Emmanuel',
    city: 'Abuja',
    story: "I attended Abuja's second edition of the networking salon and got a free Chiropractic adjustment that has relieved a major part of my back.",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8E7j4dJFgfCndoxPHot4Vw/Emmanuel.png'
  }, {
    name: 'Shobande',
    city: 'Lagos',
    story: "Someone from our Lagos community recommended me for a grant opportunity in Lagos, and though I didn't have much time to prepare, I won the grant. I was able to use the money to improve operations of my business.",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/eMK3U7TENiBNQwC2kmw1Bv/Shobande.png'
  }];
  return <section className="py-16 border-b border-gray-200 bg-secondary/5" id="success-stories" data-id="element-640">
      <div className="container mx-auto px-4" data-id="element-641">
        <h2 className="text-3xl font-bold mb-12 text-secondary-dark" data-id="element-642">
          Success Stories
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-643">
          {stories.map((story, index) => <Card key={index} className="flex flex-col" data-id="element-644">
              <div className="relative w-24 h-24 mx-auto mb-4 rounded-full overflow-hidden shadow-md border-2 border-white" data-id="element-645">
                <img src={story.image} alt={story.name} className="w-full h-full object-cover" loading="lazy" width="96" height="96" data-id="element-646" />
              </div>
              <h3 className="text-xl font-bold text-center text-primary" data-id="element-647">
                {story.name}
              </h3>
              <p className="text-secondary text-center" data-id="element-648">{story.city}</p>
              <div className="mt-4 flex-grow" data-id="element-649">
                <p className="text-center text-secondary-dark" data-id="element-650">
                  "{story.story}"
                </p>
              </div>
            </Card>)}
        </div>
        <div className="mt-12 text-center" data-id="element-651">
          <Link to="/success-stories" data-id="element-652">
            <Button data-id="element-653">Read More Stories</Button>
          </Link>
        </div>
      </div>
    </section>;
};